// extracted by mini-css-extract-plugin
module.exports = {"bigDiv":"Users_bigDiv__1QHOZ","topleft":"Users_topleft__FuTr4"};